<template name="u-upload">
  <div>
    <van-uploader  :after-read="afterRead"
             :before-delete="beforeDelete"
             v-bind="_attrs"
             v-model="fileList"
           />
  </div>
</template>

<script>
import { getAction,uploadAction } from '@/api/manage'
export default {
  name: 'u-upload',
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
  },
  created() {
   
  },
  data() {
    return {
      fileList:[],
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.fileList = this.list.map(val=>{url:val})
      },
    },
    // fileList: {
    //   immediate: true,
    //   handler() {
    //      let path = this.fileList.map(obj=>obj.url).join(',');
    //      console.log(path);
    //      this.$emit('input',path);
        
    //   },
    // },
  },
  	computed: {
			_attrs() {
				let attrs = { ...this.$attrs };
				return attrs;
			},
	},
  methods: {
    afterRead(file, detail) {
      // 此时可以自行将文件上传至服务器
      this.uploadFile(file.file, detail.index)
    },
    beforeDelete(file, detail) {
      let index = detail.index
      this.fileList.splice(index, 1)
      this.emitData();
    },
      uploadFile(file, index) {
      let url = '/sys/common/upload'
      let formData = new FormData()
      formData.append('file', file)
      uploadAction(url, formData)
        .then((res) => {
          if (res.success) {
            let url = res.message
            let obj = { url: url }
            this.fileList[index] = obj
            this.emitData();
          } else {
            this.fileList.splice(index, 1);
          }
        })
        .catch((err) => {
          // this.$toast('上传文件超时')
          this.fileList.splice(index, 1)
        })
    },
    emitData(){
      let path = this.fileList.map(obj=>obj.url).join(',');
         this.$emit('input',path);
    }
  },
 
}
</script>

<style lang="less" scoped>
</style>
